export default "__VITE_ASSET__DYzIKSDz__"